import { FC } from 'react'
import { MeetingDTO, ReplyScheduleDTO } from '../../../../api/gen/base'
import { MeetsInfoDialog } from './MeetsInfoDialog'
import { RegularRequestInfoDialog } from './RegularRequestInfoDialog'

type Props = {
    open: boolean
    onClose: VoidFunction
    data?: ReplyScheduleDTO | MeetingDTO
}

export const EventInfoDialog: FC<Props> = ({ open, onClose, data }) => {
    const isRegularRequest = data && 'reply' in data

    if (isRegularRequest) {
        return <RegularRequestInfoDialog open={open} onClose={onClose} data={data} />
    }

    return <MeetsInfoDialog open={open} onClose={onClose} data={data} />
}
